import { Routes } from '@angular/router';
import { AuthGuard } from './services/guards/auth.guard';
import { GuestGuard } from './services/guards/guest.guard';
import { adminGuard } from './services/guards/admin.guard';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./pages/login/login.routes').then(m => m.AUTH_ROUTES),
        canActivate: [GuestGuard]
    },
    {
        path:'auth/change-password',
        loadComponent: ()=> import('./pages/change-password/change-password').then((c=>c.ChangePassword)),
        canActivate:[AuthGuard]
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
        canActivate: [AuthGuard]
    },

    {
        path: 'admin',
        loadComponent: () => import('./layouts/main-layout/main.component').then(m => m.MainLayoutComponent),
        canActivate: [AuthGuard, adminGuard],
        canActivateChild: [AuthGuard, adminGuard],
        children:[
             {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full'
        },
        {
            path: 'dashboard',
            loadComponent: () =>
                import('./pages/dashboard/dashboard').then(
                    (m) => m.Dashboard
                )
        },
        {
            path: 'vagues/details/:id',
            loadComponent: () =>
                import('./pages/details-vague/details-vague').then(
                    (m) => m.DetailsVague
                )
        },
         {
            path: 'vagues/add',
            loadComponent: () =>
                import('./pages/create-vague/create-vague').then(
                    (m) => m.CreateVague),
            canActivate: [AuthGuard]
        },
        {
            path: 'vagues/edit/:id',
            loadComponent: () =>
                import('./pages/create-vague/create-vague').then(
                    (m) => m.CreateVague
                )
        },
        {
            path: 'vagues',
            loadComponent: () =>
                import('./pages/list-vague/list-vague').then(
                    (m) => m.ListVague
                )
        },
        {
            path: 'missions',
            loadComponent: () =>
                import('./pages/mission/mission').then(
                    (m) => m.Mission
                )
        },
        {
            path: 'vagues/:id/create-mission',
            loadComponent: () =>
                import('./pages/create-mission/create-mission').then(
                    (m) => m.CreateMission
                )
        },
        {
            path: 'settings',
            loadComponent: () =>
                import('./pages/setting/setting').then(
                    (m) => m.Setting
                )
        },
        {
            path: 'users',
            loadComponent: () =>
                import('./pages/users/users').then(
                    (m) => m.Users
                )
        },
        {
            path: 'users/:id/view',
            loadComponent: () =>
                import('./pages/user-detials/user-detials').then(
                    (m) => m.UserDetials
                )
        },

        {
            path: 'users/add',
            loadComponent: () =>
                import('./pages/user-create/user-create').then(
                    (m) => m.UserCreate
                )
        },
        {
            path: 'users/edit/:id',
            loadComponent: () =>
                import('./pages/user-create/user-create').then(
                    (m) => m.UserCreate
                )
        },
        {
            path: 'authorities',
            loadComponent: () =>
                import('./pages/authorities/authorities').then(
                    (m) => m.Authorities
                )
        },
        {
            path: 'import-bacheliers',
            loadComponent: () =>
                import('./pages/import-bacheliers/import-bacheliers').then(
                    (m) => m.ImportBacheliers
                )
        },
        {
            path: 'sync/logs',
            loadComponent: () =>
                import('./pages/history-sync/history-sync').then(
                    (m) => m.HistorySync
                )
        },
    ]
    },
    
    {
        path: 'profile',
        loadComponent: () => import('./layouts/main-layout/main.component').then(m => m.MainLayoutComponent),
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/profile/profile').then(m => m.ProfileComponent)
            }
        ]
    },

    {
        path: 'aide',
        loadComponent: () => import('./layouts/main-layout/main.component').then(m => m.MainLayoutComponent),
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/aide/aide').then(m => m.Aide)
            }
        ]
    },

    { path: '', redirectTo: '/auth/login', pathMatch: 'full' },

    {
        path: 'error/403',
        loadComponent: () => import('./pages/error-page/error-page').then(m => m.ErrorPageComponent),
        data: {
            code: '403',
            title: 'Accès refusé',
            description: "Vous n'avez pas les autorisations nécessaires pour accéder à cette page."
        }
    },
    {
        path: 'error/500',
        loadComponent: () => import('./pages/error-page/error-page').then(m => m.ErrorPageComponent),
        data: {
            code: '500',
            title: 'Erreur serveur',
            description: 'Une erreur inattendue est survenue. Veuillez réessayer plus tard.'
        }
    },
    {
        path: '**',
        loadComponent: () => import('./pages/error-page/error-page').then(m => m.ErrorPageComponent),
        data: {
            code: '404',
            title: 'Page introuvable',
            description: "La page que vous recherchez n'existe pas ou a été déplacée."
        }
    }
];